import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import { tripRequest } from "../../api/TripRequest";

interface Props {
  open: boolean;
  onClose: AnyFunction;
  trip?: Trip;
  onTripBlocked?: AnyFunction;
}

export default function BlockTripDialog(props: Props) {
  const { open, onClose, trip, onTripBlocked } = props;

  const handleBlockTrip = (id: number) => {
    return tripRequest.blockTrip(id).catch(() => {
      alert("S-a produs o eroare și nu este posibilă blocarea!");
    });
  };

  const handleCloseBlockTripDialog = () => {
    onClose();
  };

  return (
    <>
      <Dialog open={open}>
        <Box
          sx={{
            mt: 2,
            mb: 1,
            ml: 1,
            mr: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <BlockIcon color="error" sx={{ fontSize: "75px" }} />
          <DialogTitle>
            Sunteți sigur că doriți să blocați această comandă?
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Această comandă va fi blocată imediat.
            </DialogContentText>
          </DialogContent>
          <DialogActions
            sx={{
              minWidth: 520,
            }}
          >
            <Button
              variant="contained"
              fullWidth
              size="large"
              color="error"
              onClick={() => {
                if (trip) {
                  handleBlockTrip(trip.id)
                    .then(() => {
                      if (typeof onTripBlocked === "function") {
                        onTripBlocked();
                      }
                    })
                    .then(handleCloseBlockTripDialog);
                }
              }}
              autoFocus
            >
              Blochează
            </Button>
            <Button
              variant="outlined"
              fullWidth
              size="large"
              onClick={handleCloseBlockTripDialog}
            >
              Renunță
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
}
